const leasingResidentialTemplate = `
<!DOCTYPE html>
<html>
  <head>
  
  </head>
  <body>
  <h2 class="pdf-table-heading">Leasing</h2>
    {{#if totalUnits}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if rentableSqft}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if physicalOccupancyPC}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if leaseRenewalPC}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if startYearLeaseUnit}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if startYearLeasePC}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if newLease}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if endYearLeasePC}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if expirationsData}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{else}}{{#if residentialComment.commentText}}
    <div class="row">
      <h3 class="pdf-table-sub-heading">Residential</h3>
    {{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}
      {{#if totalUnits}}
      <!-- left table -->
      <div class="column">
        <h3>{{budgetYear}} Projected Leasing Activity</h3>
        <table id="leasing-table">
          <tr>
            <td>Total Units:</td>
            <td>{{totalUnits}}</td>
          </tr>
          <tr>
            <td>Rentable SqFt:</td>
            <td>{{rentableSqft}}</td>
          </tr>
          <tr>
            <td>Projected Avg Physical Occupancy:</td>
            <td>{{physicalOccupancyPC}}</td>
          </tr>
          <tr>
            <td>Lease Renewal%:</td>
            <td>{{leaseRenewalPC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if rentableSqft}}
      <!-- left table -->
      <div class="column">
        <h3>{{budgetYear}} Projected Leasing Activity</h3>
        <table id="leasing-table">
          <tr>
            <td>Total Units:</td>
            <td>{{totalUnits}}</td>
          </tr>
          <tr>
            <td>Rentable SqFt:</td>
            <td>{{rentableSqft}}</td>
          </tr>
          <tr>
            <td>Projected Avg Physical Occupancy:</td>
            <td>{{physicalOccupancyPC}}</td>
          </tr>
          <tr>
            <td>Lease Renewal%:</td>
            <td>{{leaseRenewalPC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if physicalOccupancyPC}}
      <!-- left table -->
      <div class="column">
        <h3>{{budgetYear}} Projected Leasing Activity</h3>
        <table id="leasing-table">
          <tr>
            <td>Total Units:</td>
            <td>{{totalUnits}}</td>
          </tr>
          <tr>
            <td>Rentable SqFt:</td>
            <td>{{rentableSqft}}</td>
          </tr>
          <tr>
            <td>Projected Avg Physical Occupancy:</td>
            <td>{{physicalOccupancyPC}}</td>
          </tr>
          <tr>
            <td>Lease Renewal%:</td>
            <td>{{leaseRenewalPC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if leaseRenewalPC}}
      <!-- left table -->
      <div class="column">
        <h3>{{budgetYear}} Projected Leasing Activity</h3>
        <table id="leasing-table">
          <tr>
            <td>Total Units:</td>
            <td>{{totalUnits}}</td>
          </tr>
          <tr>
            <td>Rentable SqFt:</td>
            <td>{{rentableSqft}}</td>
          </tr>
          <tr>
            <td>Projected Avg Physical Occupancy:</td>
            <td>{{physicalOccupancyPC}}</td>
          </tr>
          <tr>
            <td>Lease Renewal%:</td>
            <td>{{leaseRenewalPC}}</td>
          </tr>
        </table>
      </div>
      {{/if}}{{/if}}{{/if}}{{/if}}
      {{#if startYearLeaseUnit}}
      <!-- right table -->
      <div class="column">
        <h3>{{budgetYear}} Occupancy Schedule</h3>
        <table id="leasing-table">
          <tr>
            <td>#Unit Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeaseUnit}}</td>
          </tr>
          <tr>
            <td>% Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeasePC}}</td>
          </tr>
          <tr>
            <td>New Leases {{budgetYear}}:</td>
            <td>{{newLease}}</td>
          </tr>
          <tr>
            <td>% Leased 12/31/{{budgetYear}}:</td>
            <td>{{endYearLeasePC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if startYearLeasePC}}
      <!-- right table -->
      <div class="column">
        <h3>{{budgetYear}} Occupancy Schedule</h3>
        <table id="leasing-table">
          <tr>
            <td>#Unit Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeaseUnit}}</td>
          </tr>
          <tr>
            <td>% Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeasePC}}</td>
          </tr>
          <tr>
            <td>New Leases {{budgetYear}}:</td>
            <td>{{newLease}}</td>
          </tr>
          <tr>
            <td>% Leased 12/31/{{budgetYear}}:</td>
            <td>{{endYearLeasePC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if newLease}}
      <!-- right table -->
      <div class="column">
        <h3>{{budgetYear}} Occupancy Schedule</h3>
        <table id="leasing-table">
          <tr>
            <td>#Unit Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeaseUnit}}</td>
          </tr>
          <tr>
            <td>% Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeasePC}}</td>
          </tr>
          <tr>
            <td>New Leases {{budgetYear}}:</td>
            <td>{{newLease}}</td>
          </tr>
          <tr>
            <td>% Leased 12/31/{{budgetYear}}:</td>
            <td>{{endYearLeasePC}}</td>
          </tr>
        </table>
      </div>
      {{else}}{{#if endYearLeasePC}}
      <!-- right table -->
      <div class="column">
        <h3>{{budgetYear}} Occupancy Schedule</h3>
        <table id="leasing-table">
          <tr>
            <td>#Unit Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeaseUnit}}</td>
          </tr>
          <tr>
            <td>% Leased 1/1/{{budgetYear}}:</td>
            <td>{{startYearLeasePC}}</td>
          </tr>
          <tr>
            <td>New Leases {{budgetYear}}:</td>
            <td>{{newLease}}</td>
          </tr>
          <tr>
            <td>% Leased 12/31/{{budgetYear}}:</td>
            <td>{{endYearLeasePC}}</td>
          </tr>
        </table>
      </div>
      {{/if}}{{/if}}{{/if}}{{/if}}
    </div>

    {{#if expirationsData}}
    <div class="row">
      <!-- Lease Expirations table -->
      <h3 class="pdf-table-sub-heading">Lease Expirations</h3>
      <table id="print-pdf-table">
        <tr>
          <th></th>
          <th>SF Expiring</th>
          <th>% Expiring</th>
          <th>% Cumulative</th>
        </tr>
        {{#each expirationsData}}
        <tr>
          <td>{{this.expiryYear}}</td>
          <td>{{this.expiringUnit}}</td>
          <td>{{this.expiringPercentage}}</td>
          <td>{{this.cumulativePercentage}}</td>
        </tr>
        {{/each}}
      </table>
    </div>
    {{/if}}
    
    {{#if residentialComment.commentText}}
    <div class ="row">
    <br>
    <table id="comment-table">
      <tbody>
        <tr>
          <th>Comments</th>
        </tr>
        <tr>
          <td>
            {{{residentialComment.commentText}}}
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    {{/if}}
    {{#if totalUnits}}{{else}}{{#if rentableSqft}}{{else}}{{#if physicalOccupancyPC}}{{else}}{{#if leaseRenewalPC}}{{else}}{{#if startYearLeaseUnit}}{{else}}{{#if startYearLeasePC}}{{else}}{{#if newLease}}{{else}}{{#if endYearLeasePC}}{{else}}{{#if expirationsData}}{{else}}{{#if residentialComment.commentText}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}
  </body>
</html>
`;

export default leasingResidentialTemplate;
